
import React from 'react';
import { Link } from 'react-router-dom';

const TeamManagementGuide = () => {
  return (
    <div className="bg-white p-8 w-full max-w-4xl mx-auto my-8 shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-gray-200">
        使い方 - チーム管理
      </h1>
      <p className="text-lg text-gray-800 mb-6">
        「チーム管理」では、メンバーの追加や権限設定を行うことができます。<br />
        追加したメンバーは、同一契約内で請求書の発行や顧客管理（追加・削除）などの操作が可能になります。
      </p>
      <p className="text-lg text-gray-800 mb-6">
        また、機能ごとに権限を設定できるため、役割に応じた細かな業務管理が行えます。
      </p>

      <hr className="my-8 border-gray-200" />

      {/* Section 1: Inviting Members */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">メンバーの招待</h2>
        <p className="mb-4 text-gray-700">メンバーの招待を行うことでメンバーを追加できます。</p>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">メンバーの招待方法</h3>
        <ol className="list-decimal list-inside space-y-2 mb-6 bg-gray-50 p-6 rounded-lg border border-gray-200">
          <li>メールアドレスを入力し「招待を送信」ボタンを押すとメールアドレス宛に招待メールが届きます。</li>
          <li>招待されたメンバーは、メール中のリンクをクリックするとパスワード設定画面が表示されます。</li>
          <li>招待されたメンバーはパスワードを設定するとプロフィール登録画面に遷移するので、氏名、連絡先などの情報を入力。「登録完了」ボタンをクリックするとメンバーとして登録完了です。</li>
        </ol>

        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6" role="alert">
          <p className="font-bold">注意</p>
          <p className="mt-2">登録作業を途中で中止した場合、送信したメールのURLリンクが無効となります。<br/>その場合、管理者がチーム管理でメンバーを削除、再度招待してください。</p>
        </div>
      </section>

      <hr className="my-8 border-gray-200" />

      {/* Section 2: Member Permissions */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">メンバーの権限設定・変更</h2>
        <p className="mb-4 text-gray-700">
          登録されたメンバーには「請求書のアップロード」機能だけ有効となっています。管理者は役割に応じてメンバーの権限の設定、変更を行うことができます。
        </p>
        <p className="mb-6 text-gray-700">
          権限の変更は現在のチームメンバーにある「編集」ボタンをクリックすることで、対象メンバーの情報、権限を変更できます。
        </p>

        <div className="space-y-4">
            <div>
                <h3 className="text-xl font-semibold text-gray-700">メンバー情報の編集</h3>
                <p className="text-gray-600">登録済みメンバーの名前、（法人の場合は）部署、電話番号の変更ができます。</p>
            </div>
            <div>
                <h3 className="text-xl font-semibold text-gray-700">役割の変更</h3>
                <p className="text-gray-600">登録したメンバーを「管理者」に変更することができます。<br/>管理者にはすべての権限が与えられ、メンバーの招待もできます。</p>
            </div>
            <div>
                <h3 className="text-xl font-semibold text-gray-700">権限の設定</h3>
                <p className="text-gray-600">各機能ごとの操作権限と項目によっては閲覧権限を設定できます。</p>
            </div>
        </div>

        <div className="bg-blue-100 border-l-4 border-blue-500 text-blue-800 p-4 mt-6" role="alert">
          <p className="font-bold">ヒント</p>
          <p className="mt-2">機能の利用と操作、両方の権限設定ができる項目で利用の権限だけ与えた場合、その機能は表示されないため、利用することができません。<br/>もし利用権限を与えたい場合、閲覧の権限も与えてください。</p>
        </div>
      </section>

      <hr className="my-8 border-gray-200" />

      {/* Section 3: Deleting Members */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">メンバーの削除</h2>
        <p className="mb-4 text-gray-700">
          削除ボタンをクリックするとメンバー情報がすべて削除されます。
        </p>
        <p className="text-gray-700">
          Billwaveでは最低1人の管理者が必要です。管理者は自分を削除することはできないので、自分を削除する場合は、他のメンバーを管理者に設定し、その管理者に削除してもらう必要があります。
        </p>
      </section>

      <div className="mt-8 text-center">
        <Link 
          to="/support/how-to-use"
          className="inline-block bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-6 rounded-lg transition-colors"
        >
          「使い方」一覧へ戻る
        </Link>
      </div>

    </div>
  );
};

export default TeamManagementGuide;
